import { render, staticRenderFns } from "./FormVendorListContact.vue?vue&type=template&id=2a9c208c&scoped=true"
import script from "./FormVendorListContact.vue?vue&type=script&lang=js"
export * from "./FormVendorListContact.vue?vue&type=script&lang=js"
import style0 from "./FormVendorListContact.vue?vue&type=style&index=0&id=2a9c208c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c208c",
  null
  
)

export default component.exports